import {FilterValue} from "./filterValue";

export class FilterCategory {
    filterType: number;
    isExpanded: boolean = false;
    filterValues: FilterValue[];
}